import { render, staticRenderFns } from "./ChatPaletteItemTile.vue?vue&type=template&id=592b38e1&lang=pug&"
import script from "./ChatPaletteItemTile.vue?vue&type=script&lang=js&"
export * from "./ChatPaletteItemTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteItemTile.vue"
export default component.exports